import React from 'react';
import HeroCarousel from '../components/HeroCarousel';
import MassTimes from '../components/MassTimes';
import UpcomingEvents from '../components/UpcomingEvents';
import PriestMessage from '../components/PriestMessage';
import LatestNews from '../components/LatestNews';
import PhotoGallery from '../components/PhotoGallery';
import QuickAccessButtons from '../components/QuickAccessButtons';

const Home: React.FC = () => {
  return (
    <div>
      <HeroCarousel />
      <MassTimes />
      <UpcomingEvents />
      <PriestMessage />
      <LatestNews />
      <PhotoGallery />
      <QuickAccessButtons />
    </div>
  );
};

export default Home;